import React, {useEffect, useState} from 'react';
import QRCode from 'qrcode';
import {useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {qrModalVisibleSelector} from '../../store/selectors/modal';
import {roomSelector} from '../../store/selectors/roomRunFile.selectors';
import Modal from '../../ui/components/common/Modal';
import {updateQrModal} from '../../store/actions/modal.actions';
import {generateRandomQueryVals, removeQueryParam} from '../../util/url';
import {PRESENTER_QUERY_PARAM} from '../../constants';
import {PLAYER_PRES_ID_QUERY, PLAYER_ROOM_ID_QUERY} from '../../incase-domain/online';

function QrCodeModal(): JSX.Element {
    const dispatch = useDispatch();
    const location = useLocation();
    const room = useSelector(roomSelector);

    const isQrModalVisible = useSelector(qrModalVisibleSelector);

    const [qrUrl, setQrUrl] = useState('');

    useEffect(() => {
        let fullURL: string;

        if (room.roomId) {
            const url = new URL(`${window.location.origin}/room`);
            url.searchParams.set(PLAYER_ROOM_ID_QUERY, room.roomId);
            fullURL = url.toString();
        } else {
            fullURL = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
            fullURL = removeQueryParam(fullURL, PRESENTER_QUERY_PARAM);
            fullURL = generateRandomQueryVals(fullURL, [PLAYER_ROOM_ID_QUERY, PRESENTER_QUERY_PARAM, PLAYER_PRES_ID_QUERY]);
        }

        QRCode.toDataURL(fullURL, {width: 1000}, (err, url) => {
            if (!err) {
                setQrUrl(url);
            }
        });
    }, [location, room.roomId]);

    function swapVisibility(isVisible: boolean): void {
        dispatch(updateQrModal(isVisible));
    }

    function onCancel(): void {
        swapVisibility(false);
    }

    return (
        <Modal size="to-scale" isOpen={isQrModalVisible} onCancel={onCancel}>
            <div className="u-flex u-h-center u-v-center">
                <img src={qrUrl} style={{width: 'min(80vw, 80vh)'}} alt="presentation qr code" />
            </div>
        </Modal>
    );
}

export default QrCodeModal;
